var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.whatsapp_number)?_c('div',{staticClass:"logo-container"},[_c('a',{attrs:{"href":'https://api.whatsapp.com/send?phone=55'+ _vm.whatsapp_number,"target":"_blank"}},[_c('img',{attrs:{"src":require("@/assets/imgs/whatsapp.svg"),"alt":"WhatsApp logo"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }